// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  cookieDomain: 'uat-www.iprepwell.co.uk',
  ga: '',
  title: 'iPrepwell UAT',
  apiUrl: 'https://uat-api.iprepwell.co.uk',
  staticUrl: 'https://uat-static.iprepwell.co.uk',
  avatarPath : '/assets/avatar/',
  testSite: true,
  projectName: 'iPrepwell',
  pwaName: 'iPrepwell',
  languages : [
    {id: 1, language:'English', languageNative: 'English', translationFile : 'en'},
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
